module.exports = __webpack_public_path__ + "static/media/Loader.170661be.gif";